import { FC, useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { CompanyIndustryCombobox } from '../../../../../components/form/company-industry';
import { RegionsSelectCombobox } from '../../../../../components/form/regions-applicable-select';
import { FormInput } from '../../../../../components/input/index';
import { useReactForm } from '../../../../../hooks/index';
import { FormControlButtons } from '../components/form-control-buttons';
import { PerkFormSchema, perkFormSchema } from '../form.validation';
import { PerkStepFormProps } from './steps.types';

export const StepOne: FC<PerkStepFormProps> = ({
  onSubmit,
  handlePrevStep,
  patchStep,
  defaultData: { stepOne },
}) => {
  const {
    control,
    formState: { isValid },
    setValue,
    handleSubmit,
    reset,
  } = useReactForm({
    schema: perkFormSchema.shape.stepOne,
  });

  useEffect(() => {
    if (!stepOne) return;

    reset(stepOne);
  }, [stepOne, reset]);

  const submitHandler = (data: PerkFormSchema['stepOne']) => {
    onSubmit('stepOne', data);
  };

  const values = useWatch({ control });

  useEffect(() => {
    const id = setTimeout(() => {
      patchStep({ stepOne: values });
    }, 500);

    return () => clearTimeout(id);
  }, [patchStep, values]);

  return (
    <>
      <div className="invisible-y-scroll flex h-full flex-col gap-4">
        <FormInput control={control} name="companyName" placeholder="Company Name" />
        <FormInput control={control} name="url" placeholder="Website" />
        <CompanyIndustryCombobox control={control} name="industry" />
        <FormInput control={control} name="contactPerson" placeholder="Contact Person" />
        <RegionsSelectCombobox
          control={control}
          name="applicableRegions"
          placeholder="Regions Applicable (optional)"
          setValue={setValue}
        />
      </div>

      <FormControlButtons
        disabled={!isValid}
        handleNext={handleSubmit(submitHandler)}
        handlePrev={handlePrevStep}
        onFirstStep
      />
    </>
  );
};
